const RETURN_TO_KEY = "postaway_return_to";

export const getReturnTo = () => {
    if (typeof window === "undefined") return "";
    try {
        const value = sessionStorage.getItem(RETURN_TO_KEY) || "";
        sessionStorage.removeItem(RETURN_TO_KEY);
        return value.startsWith("/c/") ? value : "";
    } catch (_) {
        return "";
    }
};

export const peekReturnTo = () => {
    if (typeof window === "undefined") return "";
    try {
        const value = sessionStorage.getItem(RETURN_TO_KEY) || "";
        return value.startsWith("/c/") ? value : "";
    } catch (_) {
        return "";
    }
};
